var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    transform: "translate(-1359 -2035)",
    fill: "#180045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1360,
    y: -1957,
    width: 1920,
    height: 9087,
    fill: "#180045",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "features",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.560636 21.6836C4.72064 15.2336 9.26064 11.1236 14.2206 5.32366C15.2406 4.15366 17.5807 1.44366 18.9407 0.743658C19.7952 0.307368 20.7324 0.0568675 21.6907 0.0086075C22.649 -0.0396525 23.6066 0.115427 24.5006 0.463657C26.3706 1.11366 28.9406 3.73366 30.6306 5.36366C34.8806 9.53362 36.6606 11.5436 40.3505 15.3636C41.8505 16.9136 43.6705 18.6436 44.3705 20.4136C44.8905 21.8136 44.7905 22.2436 44.8905 23.7336C45.1205 27.6636 44.9305 31.9636 44.8405 35.8836C44.8515 37.3588 44.5665 38.8211 44.0005 40.1836C43.0205 42.0536 41.8505 42.5736 39.8405 43.0836C36.0006 44.0136 31.5206 43.9236 27.5906 43.9736C23.9906 44.0136 20.0107 44.0736 16.4107 43.9736C13.7107 43.8736 11.0407 43.8336 8.33074 43.7836C6.64074 43.7336 3.79063 43.4536 2.53063 42.3336C1.36063 41.3036 1.27064 40.8336 0.930635 39.2536C0.280635 36.1636 0.430637 31.7736 0.280637 28.5936C0.190637 26.4936 -0.039364 23.6936 0.470636 21.7736",
    fill: "#FFD15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.89117 28.8331C7.99117 25.9331 7.95117 22.7531 8.75117 19.8131C9.07117 18.5531 9.59117 17.3831 10.3412 16.3131C11.3212 14.9131 12.6312 13.8731 13.9412 12.8931C15.156 11.9961 16.4716 11.2443 17.8612 10.6531C19.6018 9.96714 21.4725 9.67414 23.3395 9.79514C25.2065 9.91614 27.0237 10.4481 28.6612 11.3531C31.9812 13.1731 34.5612 16.4531 35.7712 20.2331C36.3712 22.1931 36.6112 24.4331 35.6712 26.2131C34.7912 27.9431 33.0112 28.8731 31.3712 29.7631C28.4712 31.2631 25.5712 32.7631 22.6312 34.2531C21.9812 34.5731 21.2312 34.9531 20.4812 34.9531C19.7812 34.9531 19.1312 34.5731 18.5212 34.2531C16.6912 33.3131 14.8712 32.3331 13.0512 31.4031C11.1312 30.4231 9.17117 29.3431 7.95117 27.4231",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.380463 23.9729C3.18046 26.3529 6.18046 28.4529 9.08046 30.7029C10.2805 31.6329 11.4105 29.5729 10.2405 28.6929C7.48046 26.5929 4.64046 24.5729 2.01046 22.3329C0.890464 21.3529 -0.749537 22.9929 0.380463 23.9729ZM12.4905 32.4729C14.4005 33.6929 16.3705 34.8129 18.3805 35.9329C19.3605 36.4429 20.0105 36.9629 21.0805 36.5829C22.5405 36.0729 23.9805 35.0029 25.3405 34.2529C27.1705 33.2229 28.9905 32.1529 30.7705 31.0229C32.0305 30.2229 30.8705 28.1729 29.6005 29.0229C26.7005 30.8829 23.5205 32.3329 20.6705 34.2029C20.5705 34.2529 20.1105 34.4329 20.0605 34.5329C20.0105 34.8129 20.6605 34.7129 20.6205 34.5329C20.6205 34.3429 19.0305 33.6929 18.8905 33.5929C17.1176 32.6114 15.3704 31.5844 13.6505 30.5129C12.3905 29.6229 11.2205 31.6829 12.4905 32.4729ZM35.9605 28.4529C38.8105 26.5829 41.6105 24.6229 44.2805 22.4729C45.4505 21.5429 43.8105 19.9029 42.6405 20.8429C40.1205 22.8429 37.5005 24.7129 34.7905 26.4429C33.5305 27.2829 34.6905 29.2929 35.9605 28.4529Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9405 29.1036C7.95054 22.5636 12.7705 13.3136 19.8305 12.1036C23.9405 11.4036 28.2905 12.9436 31.0905 15.9836C34.0405 19.1536 34.4105 22.8936 34.2705 27.0536C34.2305 28.5536 36.5705 28.5536 36.6105 27.0536C36.7505 22.1536 36.0505 17.8036 32.5405 14.1536C30.828 12.4059 28.716 11.1012 26.3867 10.3521C24.0574 9.60299 21.5807 9.43189 19.1705 9.85359C10.5705 11.4936 5.29054 22.4736 8.93054 30.3236C9.54054 31.6836 11.5505 30.4636 10.9405 29.1136V29.1036Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.9303 17.703C16.9703 17.803 17.0303 17.843 17.0703 17.943C17.3503 18.453 18.1403 18.693 18.6603 18.363C19.2203 18.033 19.4103 17.333 19.0803 16.773C19.0303 16.673 18.9803 16.633 18.9403 16.543C18.6603 16.023 17.8603 15.793 17.3403 16.123C17.2092 16.1994 17.0945 16.301 17.0029 16.4219C16.9113 16.5429 16.8445 16.6807 16.8063 16.8276C16.7682 16.9745 16.7596 17.1274 16.7808 17.2777C16.8021 17.4279 16.8529 17.5725 16.9303 17.703ZM24.1703 16.633C24.1703 16.533 24.2203 16.403 24.2703 16.303C24.1303 16.583 24.0803 16.863 24.1303 17.193C24.2303 17.473 24.4103 17.753 24.6403 17.893C25.1603 18.173 26.0003 18.083 26.2403 17.473C26.3703 17.143 26.4203 16.963 26.4703 16.583C26.5103 15.983 25.9003 15.373 25.3003 15.413C24.6903 15.463 24.2203 15.983 24.1703 16.633ZM16.0403 24.433C20.1503 27.473 25.4803 27.383 29.1803 23.733C30.2503 22.663 28.6203 21.033 27.5403 22.103C24.5403 25.043 20.4803 24.853 17.2503 22.423C16.0403 21.543 14.8703 23.553 16.0403 24.433Z",
    fill: "#1E2882"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -1510,
    y: -2107,
    width: 2220,
    height: 9387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    fill: "white",
    transform: "translate(-1359 -2035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1055,
    fill: "white",
    transform: "translate(-1359 -568)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.d09938f57338c531e12b12fd5e8856c5.svg";
export { ForwardRef as ReactComponent };